import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../firebase';

const AMCScheduleView = () => {
  const { id } = useParams();
  const [schedule, setSchedule] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSchedule = async () => {
      try {
        const docRef = doc(firestore, 'AMCScheduleMaster', id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          const computedEndDate = calculateEndDate(
            data.AMCScheduleStartDate,
            data.ValueForDurationOfContraNumber,
            data.UnitForDurationOfContract
          );
          setSchedule({ id: docSnap.id, ...data, AMCScheduleEndDate: computedEndDate });
        } else {
          console.error('No such schedule!');
        }
      } catch (error) {
        console.error('Error fetching schedule:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSchedule();
  }, [id]);

  const calculateEndDate = (startDateStr, duration, unit) => {
    try {
      const startDate = new Date(startDateStr);
      const d = parseInt(duration);
      if (isNaN(d)) return 'Invalid duration';

      const endDate = new Date(startDate);
      switch (unit.toLowerCase()) {
        case 'days':
          endDate.setDate(endDate.getDate() + d);
          break;
        case 'weeks':
          endDate.setDate(endDate.getDate() + d * 7);
          break;
        case 'months':
          endDate.setMonth(endDate.getMonth() + d);
          break;
        case 'years':
          endDate.setFullYear(endDate.getFullYear() + d);
          break;
        default:
          return 'Unknown unit';
      }
      return endDate.toISOString().split('T')[0]; // YYYY-MM-DD format
    } catch (e) {
      return 'Error calculating end date';
    }
  };

  const formatDueDate = (dueDateValue) => {
    if (!dueDateValue) return '';

    const dateValue = typeof dueDateValue === 'string' ? dueDateValue.split('T')[0] : dueDateValue;
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return dueDateValue;

    const day = date.getDate();
    const monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  if (loading) return <div>Loading schedule details...</div>;
  if (!schedule) return <div>Schedule not found.</div>;

  return (
    <div style={styles.container}>
      <h2>Maintenance Schedule Details</h2>
      <div style={styles.card}>
        <p><strong>AMC Name:</strong> {schedule.AMCName}</p>
        <p><strong>Customer Name:</strong> {schedule.CustomerName}</p>
        <p><strong>Customer Email:</strong> {schedule.CustomerEmailID}</p>
        <p><strong>Schedule Start Date:</strong> {schedule.AMCScheduleStartDate}</p>
        <p><strong>Schedule End Date:</strong> {schedule.AMCScheduleEndDate}</p>
        <p><strong>Maintenance Frequency:</strong> {schedule.FreqOfMaintenance} {schedule.FreqUnit}</p>
        <p><strong>Assigned Technician:</strong> {schedule.assignedTechnicianName || schedule.assignedTechnicianEmail || 'Not assigned'}</p>
        <p><strong>Remarks:</strong> {schedule.Remarks || '—'}</p>
      </div>

      {Array.isArray(schedule.DueDatesTable) && schedule.DueDatesTable.length > 0 && (
        <div style={{ marginTop: '2rem' }}>
          <h3>Due Dates</h3>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Due Date</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Assigned To</th>
              </tr>
            </thead>
            <tbody>
              {schedule.DueDatesTable.map((row, index) => (
                <tr key={index}>
                  <td style={styles.td}>{formatDueDate(row.DueDate)}</td>
                  <td style={styles.td}>{row.Status}</td>
                  <td style={styles.td}>
                    {row.AssignedToName || row.AssignedTo || schedule.assignedTechnicianName || schedule.assignedTechnicianEmail || 'Not assigned'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <button onClick={() => navigate(-1)} style={styles.backButton}>Back</button>
    </div>
  );
};

const styles = {
  container: {
    padding: '2rem',
    maxWidth: '800px',
    margin: 'auto',
  },
  card: {
    padding: '1rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    backgroundColor: '#f5f5f5',
    marginBottom: '1rem',
  },
  backButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '1rem',
  },
  th: {
    border: '1px solid #ccc',
    padding: '8px',
    backgroundColor: '#f0f0f0',
  },
  td: {
    border: '1px solid #ccc',
    padding: '8px',
    textAlign: 'center',
  },
};

export default AMCScheduleView;
